import React from 'react';
import Layout from '../components/Layout';
import { useTranslation } from '../context/TranslationContext';
import SEO from '../components/SEO';
import { PAGE_SEO } from '../data/seoMeta';

function RefundPage() {
  var { t } = useTranslation();

  return (
    <Layout>
      <SEO title={PAGE_SEO['refund'].title} description={PAGE_SEO['refund'].description} url="/refund" />
      <div className="pt-32 pb-20 bg-black min-h-screen">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <h1 data-testid="refund-title" className="text-4xl md:text-5xl font-bold text-white mb-4">{t('refundTitle')}</h1>
          <p className="text-neutral-500 mb-12">{t('refundLastUpdated')}: March 2026</p>

          <div className="space-y-8 text-neutral-300">
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">1. {t('refundOverview')}</h2>
              <p>{t('refundOverviewText')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">2. {t('refundReturnWindow')}</h2>
              <p>{t('refundReturnWindowText')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">3. {t('refundBelloFlex')}</h2>
              <p>{t('refundBelloFlexText')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">4. {t('refundReturnShipping')}</h2>
              <p>{t('refundReturnShippingText')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">5. {t('refundProcessing')}</h2>
              <p>{t('refundProcessingText')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">6. {t('refundDamaged')}</h2>
              <p>{t('refundDamagedText')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">7. {t('refundDigital')}</h2>
              <p>{t('refundDigitalText')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">8. {t('refundCustom')}</h2>
              <p>{t('refundCustomText')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">9. {t('refundNonReturnable')}</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>{t('refundNonReturnableUsed')}</li>
                <li>{t('refundNonReturnableDigital')}</li>
                <li>{t('refundNonReturnableFinal')}</li>
                <li>{t('refundNonReturnableExpired')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">10. {t('refundExchanges')}</h2>
              <p>{t('refundExchangesText')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">11. {t('refundInternational')}</h2>
              <p>{t('refundInternationalText')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">12. {t('refundHowTo')}</h2>
              <p>{t('refundHowToText')}</p>
              <p className="mt-2">
                <a href="mailto:trumpet95@gmail.com" className="text-[#d4af37] hover:underline">trumpet95@gmail.com</a>
              </p>
              <p className="mt-2">{t('refundInclude')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">13. {t('refundContactTitle')}</h2>
              <p>{t('refundContactText')}</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Email: <a href="mailto:trumpet95@gmail.com" className="text-[#d4af37] hover:underline">trumpet95@gmail.com</a></li>
                <li>Website: <a href="/contact" className="text-[#d4af37] hover:underline">jimendez.com/contact</a></li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default RefundPage;
